import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class DeferActionsMedia extends ActionRegistryCategory {
    label = 'Medien';
    constructor(parent) {
        super(parent);
        super.init();
    }
    playMediaSequence = () => new ActionRegistryItem({
        label: 'Context-Medium abspielen',
        action: async ({ app, at }) => {
            await runtime.fetchPackages.Defer;
            await app.media.mediaReception.playMediumFromContext(at);
        },
        params: {
            core: [
                'availableMediaSequence',
                'playbackChannel',
                'playbackVolume',
                'playbackRate',
                'playbackLoop',
                'playbackStartConditions',
                'playbackAbortConditions',
                'playbackAbortRunning',
                'playbackAbortQueued',
                'sequenceStartPosition',
                'sequenceEndPosition',
            ],
        },
    });
    playLocalMediaSequence = () => new ActionRegistryItem({
        label: 'Lokales Medium abspielen',
        action: async ({ app, at }) => {
            await runtime.fetchPackages.Defer;
            await app.media.mediaReception.playMedium(at.activeOf.video || at.activeOf.sound, at);
        },
        params: {
            core: [
                'sound',
                'tts',
                'video',
                'playbackChannel',
                'playbackVolume',
                'playbackRate',
                'playbackStartConditions',
                'playbackAbortConditions',
                'playbackAbortRunning',
                'playbackAbortQueued',
                'sequenceStartPosition',
                'sequenceEndPosition',
            ],
        },
    });
    restartRecognition = () => new ActionRegistryItem({
        label: 'Restart Recognition',
        action: ({ app, runtime }) => {
            if (!runtime.availablePackages.Exotic)
                return;
            app.recognition.abortRecognition();
        },
    });
}
